/**
 * Permissions introduites par develop (planning des placiers, reporting des taux de
 * paiement), absentes du catalogue de la refonte : le backend les vérifie encore sous ces
 * noms. Pont temporaire, hors de types/Permissions.ts qui est entièrement régénéré : à
 * retirer quand le classeur les aura intégrées et que `npm run generate:permissions` les
 * aura ajoutées au catalogue.
 */
enum PendingPermissions {
  ReadPlacerSchedule = "placer_schedule.read",
  ReadOwnPlacerSchedule = "placer_schedule.read_own",
  ManagePlacerAssignments = "placer_schedule.manage_assignments",
  ManagePlacerReplacements = "placer_schedule.manage_replacements",
  CorrectPlacerScheduleHistory = "placer_schedule.correct_history",
  ViewPaymentRateReporting = "view_payment_rate_reporting",
}

export default PendingPermissions;
